import { SuspenseWithPerf } from 'reactfire';
import React, { lazy } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import {
  CheckoutUrl,
  ContentUrl,
  LandingUrl,
  LegalUrl,
  TopLevelMenuUrl,
  Url,
} from '@matematykagryzie/consts';
import { Loading } from '@matematykagryzie/ui';
import { Layout } from '@matematykagryzie/web/shell';

import { PageViewLogger } from './page-view-logger';
import { ScrollToTop } from './scroll-to-top';

// Top Level Navigation
const HomePage = lazy(() => import('@matematykagryzie/web/home-page'));
// import HomePage from '@matematykagryzie/web/home-page';
const TestimonialsPage = lazy(
  () => import('@matematykagryzie/web/testimonials')
);
const FaqPage = lazy(() => import('@matematykagryzie/web/faq'));

// Landing
const MaturaRetake = lazy(() => import('@matematykagryzie/web/matura-retake'));

// Payment Flow
const Checkout = lazy(() => import('@matematykagryzie/web/checkout'));
const PaymentConfirmation = lazy(
  () => import('@matematykagryzie/web/payment-confirmation')
);

// Content
const Sheets = lazy(() => import('@matematykagryzie/sheets'));

// Legal
const TermsOfUse = lazy(() => import('@matematykagryzie/terms-of-use'));
const PrivacyPolicy = lazy(() => import('@matematykagryzie/privacy-policy'));

export function Routing() {
  return (
    <Router>
      <Layout>
        <ScrollToTop />
        <SuspenseWithPerf
          fallback={<Loading context="Przekierowanie" />}
          traceId="load_router"
        >
          <Switch>
            {/* Menu Pages */}
            <Route exact path="/">
              <HomePage />
            </Route>
            <Route path={TopLevelMenuUrl.Testimonials}>
              <TestimonialsPage />
            </Route>
            <Route path={TopLevelMenuUrl.Faq}>
              <FaqPage />
            </Route>

            {/* Landing Pages */}
            <Route path={LandingUrl.GeneralLandingPage}>
              <HomePage />
            </Route>
            <Route path={LandingUrl.MaturaRetake}>
              <MaturaRetake />
            </Route>

            {/* Checkout */}
            <Route path={CheckoutUrl.Base}>
              <Checkout />
            </Route>

            {/* Payment Flow */}
            <Route path={Url.PaymentConfirmation}>
              <PaymentConfirmation />
            </Route>

            {/* Content */}
            <Route path={ContentUrl.Sheets}>
              <Sheets />
            </Route>

            {/* Legal */}
            <Route path={LegalUrl.TermsOfUse}>
              <TermsOfUse />
            </Route>
            <Route path={LegalUrl.PrivacyPolicy}>
              <PrivacyPolicy />
            </Route>
            <Route path={LegalUrl.GDPR}>
              <PrivacyPolicy />
            </Route>

            <Route path="*">
              <Redirect to={'/'} />
            </Route>
          </Switch>
        </SuspenseWithPerf>
        <PageViewLogger location={window.location} />
      </Layout>
    </Router>
  );
}

export default Routing;
